import configLib from '../../../configLib';
import { parsingResponseFailed } from '../../store/gateway';
import { updateSymbolStatusCache } from '../../store-util/SymbolStatusCache';
import { parseGatewayData } from '../../util/GatewayHelpers';
import { dataArrayToMap } from '../../util/MarketDataHelpers';
import { WebSocketEventData } from '../custom-event/types';
import { LoggerService } from '../logger/Logger.service';
import { GatewayRequestType, GatewayResponseSubType, GatewayResponseType } from '../web-socket/types';

import { BaseSymbolSubscriptionService } from './BaseSymbolSubscription.service';
import { SymbolSubscriptionRequestType } from './types';

const LOG_PREFIX = '[SS-SUBS]';
const logger = LoggerService.getLogger();

/**
 * Foreign Exchange Subscription Service
 */
export class SymbolStatusSubscriptionService extends BaseSymbolSubscriptionService<SymbolSubscriptionRequestType> {
  private static instance: SymbolStatusSubscriptionService;

  // Make the constructor private, to have a single instance
  // eslint-disable-next-line no-useless-constructor
  private constructor() {
    super();
  }

  static getInstance(): SymbolStatusSubscriptionService {
    if (!this.instance) {
      this.instance = new SymbolStatusSubscriptionService();
    }

    return this.instance;
  }

  // TODO: HW-1162  Cover all cases with unittesting
  public handleResponseEvent = (event: WebSocketEventData<any>): void => {
    if (event.data.messageSubType !== GatewayResponseSubType.SymbolStatus) {
      return;
    }
    const data = event.data ?? {};
    let parsedData;

    try {
      parsedData = parseGatewayData(data);
    } catch (error) {
      configLib.store.dispatch(parsingResponseFailed(`${error}`));
      return;
    }

    logger.log(`${LOG_PREFIX} SymbolStatusSubscriptionService response! data:`, event);

    parsedData = {
      raw: data,
      final: dataArrayToMap(parsedData),
    };

    updateSymbolStatusCache(parsedData.final);
  };

  protected getResponseType = (): GatewayResponseType => GatewayResponseType.MarketData;

  protected getSubscriptionRequestType = (): GatewayRequestType => GatewayRequestType.MarketDataSubscribeSymbolStatus;

  protected getUnsubscriptionRequestType = (): GatewayRequestType => GatewayRequestType.MarketDataUnsubscribeSymbolStatus;
}
